module.exports = __webpack_public_path__ + "static/img/logo92.71ab881.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo92.png
// module id = jLZH
// module chunks = 1